import { Injectable, ViewContainerRef, inject, signal } from '@angular/core';
import { HlmDialogOpener } from '@lite-workspace/shared/helm-ui/dialog';
import { OrganizerShareDialogComponent, type OrganizerShareContext } from './organizer-share-dialog.component';
import type { StepCounts } from './step-chip.component';

export type OrganizerShareMode = Pick<
  OrganizerShareContext,
  'organizerOnly' | 'groupMode' | 'linksOnly' | 'pinsOnly' | 'organizerView' | 'tab'
>;

@Injectable({ providedIn: 'root' })
export class OrganizerShareLauncherService {
  private readonly opener = inject(HlmDialogOpener);
  /** Class progress of the open albums page: every entry (header button, step menu) hands the same counts. */
  private readonly pageCounts = signal<{ projectId: string; counts: StepCounts | null } | null>(null);

  setPageStepCounts(projectId: string, counts: StepCounts | null): void {
    this.pageCounts.set({ projectId, counts });
  }

  clearPageStepCounts(): void {
    this.pageCounts.set(null);
  }

  // The dialog opens on the click itself and reads its own links and subtitle behind skeletons — a
  // pre-open fetch held the modal back by a full round-trip on every surface.
  open(vcr: ViewContainerRef | undefined, projectId: string, mode: OrganizerShareMode = {}): void {
    const page = this.pageCounts();
    const stepCounts = page?.projectId === projectId ? page.counts : null;
    this.opener.open<OrganizerShareContext, boolean>(
      OrganizerShareDialogComponent,
      vcr,
      stepCounts ? { projectId, ...mode, stepCounts } : { projectId, ...mode },
      // autoFocus 'dialog', not 'first-tabbable': the first tabbable element is the header close cross —
      // auto-focusing it would light its focus state on every open.
      { autoFocus: 'dialog' },
    );
  }

  // «Отправить группе» on the organizer's own Ученики screen: the SAME group-mode window the
  // photographer gets, plus the organizer flag that switches its banner copy.
  openForOrganizer(projectId: string): void {
    this.open(undefined, projectId, { groupMode: true, organizerView: true });
  }
}
